"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));
var atoms_1 = require("../../atoms");
var styles_1 = require("./styles");
exports.RadioButtonGroup = (0, react_1.forwardRef)(function (_a, ref) {
    var label = _a.label, defaultValue = _a.defaultValue, id = _a.id, _b = _a.row, row = _b === void 0 ? true : _b, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, options = _a.options, error = _a.error, helperText = _a.helperText, _d = _a.headerHighLight, headerHighLight = _d === void 0 ? true : _d, textProps = _a.textProps, rest = __rest(_a, ["label", "defaultValue", "id", "row", "onChange", "options", "error", "helperText", "headerHighLight", "textProps"]);
    var classes = (0, styles_1.useStyles)({ headerHighLight: headerHighLight });
    var _e = (0, react_1.useState)(defaultValue), value = _e[0], setValue = _e[1];
    var handleChange = function (event) {
        var selectedValue = event.target.value;
        setValue(selectedValue);
        // TODO: most likely not necessary since state is controlled here
        onChange(event, selectedValue);
    };
    return ((0, jsx_runtime_1.jsxs)(FormControl_1.default, __assign({ component: "fieldset", error: error }, { children: [(0, jsx_runtime_1.jsx)(FormLabel_1.default, __assign({ component: "legend" }, { children: (0, jsx_runtime_1.jsx)(atoms_1.Text, __assign({ type: "text", weight: "bold", className: classes.label }, textProps, { children: label })) })), (0, jsx_runtime_1.jsx)(RadioGroup_1.default, __assign({ id: id, row: row, "aria-label": label, name: label, value: value, onChange: handleChange, ref: ref }, rest, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(atoms_1.RadioButton, __assign({}, option), option.id)); }) })), error && ((0, jsx_runtime_1.jsx)(FormHelperText_1.default, __assign({ id: "helperTextRadio", className: classes.errorMessage }, { children: helperText })))] })));
});
